import * as React from "react";
import {Modal} from "react-bootstrap";
import {Alert} from "../form/Alert";

interface State {
    show?: boolean
    error?: string;
    inProgress?: boolean
}

export class DeleteButtonModal extends React.Component<{ iconClassName?: string; label?: string; description?: string, category?: string; onDelete: () => Promise<any>, onCancel?: () => void, className?: string }, State> {

    constructor(props) {
        super(props);
        this.state = {show: false, inProgress: false};
    }

    cancel(): void {
        this.setState({show: false, error: undefined});
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    doDelete(): void {
        if (this.state.inProgress == true) {
            return;
        }
        this.setState({show: false});
        if (this.props.onDelete) {
            this.setState({inProgress: true});
            let promise = this.props.onDelete();
            promise.then(() => {
                this.setState({show: false, error: undefined, inProgress: false});
            }).catch(err => {
                this.setState({show: true, error: err, inProgress: false});
            });
        }
    }

    getDeleteInfo(): JSX.Element {
        if (this.state.error != null) {
            return;
        }

        return (
            <div>
                <div>You are about to {this.getLabel()} {this.props.description}</div>
                {this.getWarningMessage()}
            </div>

        )
    }

    getDeleteError(): JSX.Element  {
        if (this.state.error == null) {
            return;
        }
        let text = "Unable to " + this.getLabel() + this.props.description;
        return <Alert type="danger" text={text}/>
    }

    getActions(): JSX.Element {
        if (this.state.error != null) {
            return (
                <a className="btn btn-default" onClick={this.cancel.bind(this)}>Continue</a>
            );
        }
        return (
            <div>
                <a className="btn btn-default" onClick={this.cancel.bind(this)}>Cancel</a>
                <a className="btn btn-danger" onClick={this.doDelete.bind(this)}
                   disabled={this.state.inProgress}>{this.getLabel()}</a>
            </div>
        );
    }

    getLabel(): String {
        if (this.props.label) {
            return this.props.label;
        }
        return "Delete";
    }

    getWarningMessage(): JSX.Element {
        if (this.props.category === "TICKET") {
            return (
                <div><b>Warning!</b> Deleting tickets can prevent tournaments from appearing in the lobby if they are still referenced by games/tournaments.</div>
            )
        }
    }

    render() {
        return (

            <a onClick={() => {
                this.setState({show: true})
            }} className={this.props.className}>
                <i className={this.props.iconClassName}></i> {this.getLabel()}
                <Modal show={this.state.show} onHide={this.cancel.bind(this)}
                       aria-labelledby="contained-modal-title">
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">Are sure you want to {this.getLabel()} this {this.props.category}?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.getDeleteInfo()}
                        {this.getDeleteError()}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.getActions()}
                    </Modal.Footer>
                </Modal>
            </a>


        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/util/DeleteButtonModal.tsx